// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* === base (index.css) === */
/* ルートは高さを持たせ、body は常に縦スクロール可能に */
html, body, #root {
  height: 100%;
}
html, body {
  margin: 0;
  font-family: 'IBM Plex Sans JP', 'IBM Plex Sans', system-ui, -apple-system, BlinkMacSystemFont, '.SFNSText-Regular', sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
}
body {
  overflow-y: auto;
}

/* 必要なら強めの上書きはここ1箇所に集約 */
body, .bx--body, * {
  font-family: 'IBM Plex Sans JP', 'IBM Plex Sans', sans-serif !important;
}

/* 見出し（コンパクト版） */
h1, h2, h3, h4, h5, h6 {
  font-weight: 600;
  color: #222;
  line-height: 1.4;
  margin: 1rem 0 0.5rem;
}
h1 { font-size: 1.8rem; }
h2 { font-size: 1.6rem; }
h3 { font-size: 1.4rem; }
h4 { font-size: 1.2rem; }
h5 { font-size: 1rem; }
h6 { font-size: 0.9rem; }

/* レイアウト */
.flex-container {
  display: flex;
  flex-direction: column;
  width: 100%;
  /* Safari で子スクロールを殺さないおまじない */
  min-height: 0;
}
@media (min-width: 1100px) {
  .flex-container {
    flex-direction: row;
    gap: 2rem;
    justify-content: space-between;
    flex-wrap: nowrap;
  }
  .chartContainer { margin-bottom: 0; }
}
.chartContainer--left, .chartContainer--right {
  flex: 1 1;
  max-width: none;
  min-height: 0; /* 子スクロール保護 */
}

/* モーダル・入力など（Carbon上書き） */
.cds--select__arrow { height: 40px !important; align-self: center; }
.cds--slider { min-width: 200px; }
.cds--slider__track::before { display: none !important; }
.cds--modal-footer { display: none !important; }
.custom-modal-width .cds--modal-container { width: 350px !important; max-width: 90vw !important; }
.custom-modal-width .cds--modal-content { padding: 0 !important; }
.cds--text-input, .cds--dropdown, .cds--date-picker__input { width: 100% !important; min-width: 0 !important; }
.cds--date-picker__icon { height: 40px !important; margin-top: 0 !important; padding-top: 0 !important; align-self: center; }

/* NumberInput 整列（縦中央に寄せたい例） */
.cds--number__input-wrapper {
  margin-bottom: 0 !important;
  align-items: center !important;
  height: 40px;
}
.cds--number__controls { height: 40px !important; margin-top: 0 !important; padding-top: 0 !important; align-self: center; }
.cds--number__control-btn { height: 40px; line-height: 1; margin-top: 0 !important; padding-top: 0 !important; align-self: center; }
.cds--number__invalid { margin-top: 12px; }

/* ドロップダウン/メニューの配色 */
.cds--list-box__menu,
.cds--menu { background-color: var(--cds-layer, #fff) !important; color: var(--cds-text-primary, #161616) !important; }
.cds--list-box__menu-item__option,
.cds--menu-item__label,
.cds--menu button { color: var(--cds-text-primary, #161616) !important; }
.cds--list-box__menu button,
.cds--menu button { background: transparent !important; border: 0 !important; box-shadow: none !important; }

/* モーダル上下のグラデーション削除 */
.cds--modal-scroll-content::before,
.cds--modal-scroll-content::after { content: none !important; background: none !important; }

/* テーブル固定ヘッダースクロール（挙動は従来通り） */
.table-scroll thead { display: table; width: 100%; table-layout: fixed; }
.table-scroll tbody { display: block; max-height: 360px; overflow-y: auto; -webkit-overflow-scrolling: touch; }
.table-scroll tbody tr { display: table; width: 100%; table-layout: fixed; }
.table-scroll { border-collapse: separate; border-spacing: 0; }

/* 画面中央レイアウト／vhの改善 */
/* ログイン画面など“単独ページ”のみで利用。ダッシュボードでは使わない想定のまま */
.start-container {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  min-height: 100dvh; /* 100vh → 100dvh でモバイルのアドレスバー変動に追従 */
  text-align: center;
}

/* === Carbon form items margin reset (全体適用) === */
.cds--form-item {
  margin-bottom: 0 !important;
  margin-block-end: 0 !important;
}

/* 念のため input 系個別もゼロに */
.cds--text-input,
.cds--number,
.cds--password-input,
.cds--date-picker,
.cds--dropdown,
.cds--select {
  margin-bottom: 0 !important;
}

.cds--tooltip {
  z-index: 9999 !important;
}`, "",{"version":3,"sources":["webpack://./src/index.css"],"names":[],"mappings":"AAAA,6BAA6B;AAC7B,iCAAiC;AACjC;EACE,YAAY;AACd;AACA;EACE,SAAS;EACT,+HAA+H;EAC/H,mCAAmC;EACnC,kCAAkC;AACpC;AACA;EACE,gBAAgB;AAClB;;AAEA,wBAAwB;AACxB;EACE,uEAAuE;AACzE;;AAEA,gBAAgB;AAChB;EACE,gBAAgB;EAChB,WAAW;EACX,gBAAgB;EAChB,qBAAqB;AACvB;AACA,KAAK,iBAAiB,EAAE;AACxB,KAAK,iBAAiB,EAAE;AACxB,KAAK,iBAAiB,EAAE;AACxB,KAAK,iBAAiB,EAAE;AACxB,KAAK,eAAe,EAAE;AACtB,KAAK,iBAAiB,EAAE;;AAExB,UAAU;AACV;EACE,aAAa;EACb,sBAAsB;EACtB,WAAW;EACX,6BAA6B;EAC7B,aAAa;AACf;AACA;EACE;IACE,mBAAmB;IACnB,SAAS;IACT,8BAA8B;IAC9B,iBAAiB;EACnB;EACA,kBAAkB,gBAAgB,EAAE;AACtC;AACA;EACE,SAAW;EACX,eAAe;EACf,aAAa,EAAE,aAAa;AAC9B;;AAEA,yBAAyB;AACzB,sBAAsB,uBAAuB,EAAE,kBAAkB,EAAE;AACnE,eAAe,gBAAgB,EAAE;AACjC,8BAA8B,wBAAwB,EAAE;AACxD,qBAAqB,wBAAwB,EAAE;AAC/C,4CAA4C,uBAAuB,EAAE,0BAA0B,EAAE;AACjG,0CAA0C,qBAAqB,EAAE;AACjE,6DAA6D,sBAAsB,EAAE,uBAAuB,EAAE;AAC9G,0BAA0B,uBAAuB,EAAE,wBAAwB,EAAE,yBAAyB,EAAE,kBAAkB,EAAE;;AAE5H,8BAA8B;AAC9B;EACE,2BAA2B;EAC3B,8BAA8B;EAC9B,YAAY;AACd;AACA,yBAAyB,uBAAuB,EAAE,wBAAwB,EAAE,yBAAyB,EAAE,kBAAkB,EAAE;AAC3H,4BAA4B,YAAY,EAAE,cAAc,EAAE,wBAAwB,EAAE,yBAAyB,EAAE,kBAAkB,EAAE;AACnI,wBAAwB,gBAAgB,EAAE;;AAE1C,oBAAoB;AACpB;aACa,mDAAmD,EAAE,kDAAkD,EAAE;AACtH;;oBAEoB,kDAAkD,EAAE;AACxE;oBACoB,kCAAkC,EAAE,oBAAoB,EAAE,2BAA2B,EAAE;;AAE3G,qBAAqB;AACrB;oCACoC,wBAAwB,EAAE,2BAA2B,EAAE;;AAE3F,6BAA6B;AAC7B,sBAAsB,cAAc,EAAE,WAAW,EAAE,mBAAmB,EAAE;AACxE,sBAAsB,cAAc,EAAE,iBAAiB,EAAE,gBAAgB,EAAE,iCAAiC,EAAE;AAC9G,yBAAyB,cAAc,EAAE,WAAW,EAAE,mBAAmB,EAAE;AAC3E,gBAAgB,yBAAyB,EAAE,iBAAiB,EAAE;;AAE9D,oBAAoB;AACpB,4CAA4C;AAC5C;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,uBAAuB;EACvB,kBAAkB,EAAE,qCAAqC;EACzD,kBAAkB;AACpB;;AAEA,kDAAkD;AAClD;EACE,2BAA2B;EAC3B,8BAA8B;AAChC;;AAEA,uBAAuB;AACvB;;;;;;EAME,2BAA2B;AAC7B;;AAEA;EACE,wBAAwB;AAC1B","sourcesContent":["/* === base (index.css) === */\n/* ルートは高さを持たせ、body は常に縦スクロール可能に */\nhtml, body, #root {\n  height: 100%;\n}\nhtml, body {\n  margin: 0;\n  font-family: 'IBM Plex Sans JP', 'IBM Plex Sans', system-ui, -apple-system, BlinkMacSystemFont, '.SFNSText-Regular', sans-serif;\n  -webkit-font-smoothing: antialiased;\n  -moz-osx-font-smoothing: grayscale;\n}\nbody {\n  overflow-y: auto;\n}\n\n/* 必要なら強めの上書きはここ1箇所に集約 */\nbody, .bx--body, * {\n  font-family: 'IBM Plex Sans JP', 'IBM Plex Sans', sans-serif !important;\n}\n\n/* 見出し（コンパクト版） */\nh1, h2, h3, h4, h5, h6 {\n  font-weight: 600;\n  color: #222;\n  line-height: 1.4;\n  margin: 1rem 0 0.5rem;\n}\nh1 { font-size: 1.8rem; }\nh2 { font-size: 1.6rem; }\nh3 { font-size: 1.4rem; }\nh4 { font-size: 1.2rem; }\nh5 { font-size: 1rem; }\nh6 { font-size: 0.9rem; }\n\n/* レイアウト */\n.flex-container {\n  display: flex;\n  flex-direction: column;\n  width: 100%;\n  /* Safari で子スクロールを殺さないおまじない */\n  min-height: 0;\n}\n@media (min-width: 1100px) {\n  .flex-container {\n    flex-direction: row;\n    gap: 2rem;\n    justify-content: space-between;\n    flex-wrap: nowrap;\n  }\n  .chartContainer { margin-bottom: 0; }\n}\n.chartContainer--left, .chartContainer--right {\n  flex: 1 1 0;\n  max-width: none;\n  min-height: 0; /* 子スクロール保護 */\n}\n\n/* モーダル・入力など（Carbon上書き） */\n.cds--select__arrow { height: 40px !important; align-self: center; }\n.cds--slider { min-width: 200px; }\n.cds--slider__track::before { display: none !important; }\n.cds--modal-footer { display: none !important; }\n.custom-modal-width .cds--modal-container { width: 350px !important; max-width: 90vw !important; }\n.custom-modal-width .cds--modal-content { padding: 0 !important; }\n.cds--text-input, .cds--dropdown, .cds--date-picker__input { width: 100% !important; min-width: 0 !important; }\n.cds--date-picker__icon { height: 40px !important; margin-top: 0 !important; padding-top: 0 !important; align-self: center; }\n\n/* NumberInput 整列（縦中央に寄せたい例） */\n.cds--number__input-wrapper {\n  margin-bottom: 0 !important;\n  align-items: center !important;\n  height: 40px;\n}\n.cds--number__controls { height: 40px !important; margin-top: 0 !important; padding-top: 0 !important; align-self: center; }\n.cds--number__control-btn { height: 40px; line-height: 1; margin-top: 0 !important; padding-top: 0 !important; align-self: center; }\n.cds--number__invalid { margin-top: 12px; }\n\n/* ドロップダウン/メニューの配色 */\n.cds--list-box__menu,\n.cds--menu { background-color: var(--cds-layer, #fff) !important; color: var(--cds-text-primary, #161616) !important; }\n.cds--list-box__menu-item__option,\n.cds--menu-item__label,\n.cds--menu button { color: var(--cds-text-primary, #161616) !important; }\n.cds--list-box__menu button,\n.cds--menu button { background: transparent !important; border: 0 !important; box-shadow: none !important; }\n\n/* モーダル上下のグラデーション削除 */\n.cds--modal-scroll-content::before,\n.cds--modal-scroll-content::after { content: none !important; background: none !important; }\n\n/* テーブル固定ヘッダースクロール（挙動は従来通り） */\n.table-scroll thead { display: table; width: 100%; table-layout: fixed; }\n.table-scroll tbody { display: block; max-height: 360px; overflow-y: auto; -webkit-overflow-scrolling: touch; }\n.table-scroll tbody tr { display: table; width: 100%; table-layout: fixed; }\n.table-scroll { border-collapse: separate; border-spacing: 0; }\n\n/* 画面中央レイアウト／vhの改善 */\n/* ログイン画面など“単独ページ”のみで利用。ダッシュボードでは使わない想定のまま */\n.start-container {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  min-height: 100dvh; /* 100vh → 100dvh でモバイルのアドレスバー変動に追従 */\n  text-align: center;\n}\n\n/* === Carbon form items margin reset (全体適用) === */\n.cds--form-item {\n  margin-bottom: 0 !important;\n  margin-block-end: 0 !important;\n}\n\n/* 念のため input 系個別もゼロに */\n.cds--text-input,\n.cds--number,\n.cds--password-input,\n.cds--date-picker,\n.cds--dropdown,\n.cds--select {\n  margin-bottom: 0 !important;\n}\n\n.cds--tooltip {\n  z-index: 9999 !important;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
